import { useState } from "react";
import { toast } from "react-toastify";
import { useImportExcelPhytosanitaryProgram, useValidatePhytosanitaryProgramName } from "@/hooks/planning/phytosanitary-program/usePhytosanitaryProgram";

export const usePhytosanitaryImport = (inputRef, setInfoMessages, setMessageType) => {
	const [showConfirmModal, setShowConfirmModal] = useState(false);
	const [validationData, setValidationData] = useState(null);
	const [pendingFile, setPendingFile] = useState(null);

	const { mutate: importExcel, isLoading: isLoadingImport } = useImportExcelPhytosanitaryProgram();
	const { mutate: validateProgram, isLoading: isValidating } = useValidatePhytosanitaryProgramName();

	const handleImportClick = () => {
		if (inputRef.current) {
			inputRef.current.click();
		}
	};

	const processImport = (file) => {
		const formData = new FormData();
		formData.append("file", file);

		importExcel(formData, {
			onSuccess: (response) => {
				inputRef.current.value = null;
				setPendingFile(null);
				setShowConfirmModal(false);
				setValidationData(null);

				if (response?.message) {
					toast.success(response.message);
				} else {
					toast.success("Excel importado correctamente");
				}
			},
			onError: (error) => {
				inputRef.current.value = null;
				setPendingFile(null);
				setShowConfirmModal(false);
				setValidationData(null);

				if (error?.response?.data?.messages && error.response.data.messages.length > 0) {
					setInfoMessages(error.response.data.messages);
					setMessageType(error.response.data.message_type);
				} else {
					toast.error(error?.response?.data?.message || "Error al importar Excel");
				}
			},
		});
	};

	const handleFileChange = (event) => {
		const file = event.target.files[0];

		if (!file) {
			return;
		}

		validateProgram(file, {
			onSuccess: (response) => {
				if (response.exists) {
					setValidationData(response);
					setPendingFile(file);
					setShowConfirmModal(true);
				} else {
					processImport(file);
				}
			},
			onError: (error) => {
				inputRef.current.value = null;

				if (error?.response?.data?.messages && error.response.data.messages.length > 0) {
					setInfoMessages(error.response.data.messages);
					setMessageType(error.response.data.message_type);
				} else {
					toast.error(error?.response?.data?.error || "Error validando programa");
				}
			},
		});
	};

	const handleConfirmImport = () => {
		if (pendingFile) {
			processImport(pendingFile);
		}
	};

	const handleCancelImport = () => {
		inputRef.current.value = null;
		setPendingFile(null);
		setShowConfirmModal(false);
		setValidationData(null);
	};

	return {
		isLoadingImport: isLoadingImport || isValidating,
		showConfirmModal,
		validationData,
		handleImportClick,
		handleFileChange,
		handleConfirmImport,
		handleCancelImport,
	};
};
